import { render, staticRenderFns } from "./SurveyPackagingList.vue?vue&type=template&id=2da89984"
import script from "./SurveyPackagingList.vue?vue&type=script&lang=js"
export * from "./SurveyPackagingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports